import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    circle: (isDisabled: boolean) => ({
      cursor: isDisabled ? 'default' : 'pointer',
      width: '50px',
      height: '50px',
      borderRadius: '25px',
      border: isDisabled
        ? `2px solid ${colors.grey_10}`
        : `2px solid ${colors.black}`,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      position: 'relative',
    }),
    arrowIcon: (isDisabled: boolean) => ({
      fill: 'none',
      stroke: isDisabled ? colors.grey_10 : colors.black,
    }),
  };
};
